import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { FontSizeProvider } from './FontSizeContext';
import { BrowserRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';
function setCanonicalURL() {
  const canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink) {
    canonicalLink.href = window.location.href; // Set canonical URL to current page URL
  }
}
ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<FontSizeProvider>
				<App />
			</FontSizeProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
);
setCanonicalURL()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
